/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlusEqual = createReactComponent("outline", "plus-equal", "IconPlusEqual", [["path", { "d": "M4 7h6", "key": "svg-0" }], ["path", { "d": "M7 4v6", "key": "svg-1" }], ["path", { "d": "M20 16h-6", "key": "svg-2" }], ["path", { "d": "M20 19h-6", "key": "svg-3" }], ["path", { "d": "M5 19l14 -14", "key": "svg-4" }]]);

export { IconPlusEqual as default };
//# sourceMappingURL=IconPlusEqual.mjs.map
